import React from "react";
import { NewTab, PageTabAdv } from "../../../components";
import InterviewFollowup from "./InterviewFollowup/InterviewFollowup";
import { useModuleAccess } from "../../../hooks";

const InterviewFollowups = () => {
  const InterviewFollowupMenus = [
    {
      title: "Interview Followup",
      page: <InterviewFollowup />,
      type: "main",
      id: "recruitmentinterviewfollowup_interviewfollowup",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: InterviewFollowupMenus,
    parentId: "recruitmentinterviewfollowup",
  });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="interview-followup"
    />
  );
};

export default InterviewFollowups;
